import { createOidcAuth, LogLevel, SignInType } from 'vue-oidc-client/vue3'

let mainOidc = null

if (window.auth) {

    if (process.env.VUE_APP_SSO_URL != undefined) {
        window.auth.authority = process.env.VUE_APP_SSO_URL;
        window.auth.metadata = {
            issuer: process.env.VUE_APP_SSO_URL,
            authorization_endpoint: `${process.env.VUE_APP_SSO_URL}/OAUTH2/authserver.php`,
            token_endpoint: `${process.env.VUE_APP_SSO_URL}/OAUTH2/authserver.php`,
            userinfo_endpoint:
                `${process.env.VUE_APP_SSO_URL}/api/adas/openidconnect/userinfo`,
            jwks_uri: `${process.env.VUE_APP_SSO_URL}/OIDC/.well-known/jwks.json`,
            end_session_endpoint: `${process.env.VUE_APP_SSO_URL}/status/`,
        };
    }
    if (process.env.VUE_APP_SSO_CLIENT_ID != undefined) {
        window.auth.client_id = process.env.VUE_APP_SSO_CLIENT_ID;
        window.auth.scope = `openid profile email api ${process.env.VUE_APP_SSO_CLIENT_ID}`;
    }

    const loco = window.location
    const appRootUrl = `${loco.protocol}//${loco.host}${process.env.BASE_URL}`;
    mainOidc = createOidcAuth(
        'main',
        SignInType.Window,
        appRootUrl,
        window.auth,
        console,
        LogLevel.Error
    )
}

export default mainOidc
